import { VirtualizedListItem } from "../../components/virtualized-list/VirtualizedList";
import Enumerable from "linq";
import { IObjectPropertyListModel, IPollingSchedule, ISpotTagPollingScheduleModel, ITagPollingSchedule, ITagPollingScheduleUpdateModel } from "../../services/properties-data-service/Models";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type PollingScheduleFormListItem = {

    fieldKey: string
} & IPollingSchedule & VirtualizedListItem;


export type PollingScheduleForm = {
    scheduleID: number,
    pollingSchedules: PollingScheduleFormListItem[]
};

export const defaultPollingScheduleForm: PollingScheduleForm = {
    scheduleID: -1,
    pollingSchedules: []
    
};

export const CUSTOM_SCHEDULE_ID = 0;

const ModifyPollingScheduleUtils = {
    mapToModel: (form: PollingScheduleForm
    ): ITagPollingScheduleUpdateModel=> {

        const model: ITagPollingScheduleUpdateModel = {
        }

        if (form.scheduleID === CUSTOM_SCHEDULE_ID) {

            model.items = form.pollingSchedules
                .filter(o => o.scheduleID !== o.originalScheduleId)
                .map(o => {
                    return {
                        tagID: o.tagID,
                        tagName: o.tagName,
                        tagVisible: o.tagVisible,
                        scheduleID: o.scheduleID
                    } as ISpotTagPollingScheduleModel
                });
        } else {
            model.items = [];
            model.singleSchedule = form.scheduleID
        }

        return model;
    },
    mapToFormValues: (elynxObject: IeLynxObject,
        model: IPollingSchedule[], 
        referenceData: IObjectPropertyListModel): PollingScheduleForm  => {

        const formValues: PollingScheduleForm = {
            scheduleID: -1,
            pollingSchedules: Enumerable.from(model)
            .join(referenceData.tagPollingSchedules,
                o => o.scheduleID,
                v => v.id,
                (o, v) => {

                    return {
                        tagID: o.tagID,
                        tagName: o.tagName,
                        tagVisible: o.tagVisible,
                        scheduleID: o.scheduleID,
                        originalScheduleId: o.scheduleID,
                        scheduleName: v.description,
                        object: elynxObject,
                        tagAssociationTypeID: o.tagAssociationTypeID
                    } as PollingScheduleFormListItem;
                }
            ).toArray()
        };

        const schedulesInUse = Enumerable.from(model)
            .select(o => o.scheduleID)
            .distinct()
            .toArray();

        formValues.scheduleID = schedulesInUse.length === 1 ? 
                                    schedulesInUse[0] : 
                                schedulesInUse.length > 1 ?
                                CUSTOM_SCHEDULE_ID :
                                -1;

        return formValues;
    },
    filterItems: (data: PollingScheduleFormListItem[], 
        filter: string,
        selectedSchedules: ITagPollingSchedule[]
    ) : PollingScheduleFormListItem[] => {

        let result = data.filter(o => (filter.trim() === '' ||
                                o.tagName.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1));

        if (result.length > 0 && !selectedSchedules.some(o => o.id === -1 && o.selected)) {


            result = Enumerable.from(result)
                        .join(selectedSchedules.filter(o => o.selected), 
                            o => o.scheduleID,
                            v => v.id,
                            (o, v) => o).toArray();
        }


        return result;                                
    }        
}

export default ModifyPollingScheduleUtils;
